import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { db } from '../../../../firebase';
import { collection, onSnapshot, query } from 'firebase/firestore';
import { settingsLoadedAction } from '../../../actions/preloaded';
import { dataCompletedAction } from '../../../actions/store';

const useSettingsLoader = () => {
  const [options, setOptions] = useState({ execute: false });

  const user = useSelector(state => state.User);
  const [loaded, setLoaded] = useState(false);
  const dispatch = useDispatch();

  const load = () => {
    dispatch(dataCompletedAction({ slice: 'Preloaded', path: 'settings' }));
    setLoaded(true);
    return onSnapshot(
      query(collection(db, 'settings')),
      querySnapshot => {
        const items = [];

        querySnapshot.forEach(doc => {
          const dataItem = doc.data();
          dataItem.id = doc.id;
          items.push(dataItem);
        });

        dispatch(settingsLoadedAction(items));
      },
      error => {
        console.error('useSettingsLoader.onSnapshot', error);
      }
    );
  };

  useEffect(() => {
    //let unSub = () => {};

    if (
      options.execute &&
      !loaded
      //(user?.role === 'admin' || user.role === 'owner')
    ) {
      //unSub = load();
      load();
    }
    return () => {
      //unSub();
    };
  }, [options, user]);

  return {
    loadSettings: (options = {}) => {
      setOptions({ ...options, execute: true });
    }
  };
};

export default useSettingsLoader;
